import { globalStores } from '@/editor/stores';
import { BufferGeometry, LineSegments, MeshBasicMaterial, Vector2 } from 'three';
import BaseModel2d from './BaseModel2d';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { defaultOutlineColor, ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { pixelRatio2d } from '@/editor/math/const';
import { ArcSeg2d } from '@/editor/math/arcSeg2d';
import { isArc } from '@/editor/utils/arc';

export default class WallOutlineModel extends BaseModel2d {
  private _lineMaterial: MeshBasicMaterial;
  private _lines: Vector2[] = [];
  constructor() {
    super();

    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);

    this._lineMaterial = new MeshBasicMaterial({ color: defaultOutlineColor });

    this.setDisplayOrder(ENTITY_RENDER_ORDER.wallOutline);
  }

  get modelGroup() {
    return this._modelGroup;
  }

  update(params: { edges: { start: IPoint2d; end: IPoint2d; center?: IPoint2d; clockwise?: boolean }[] }) {
    const lines: Vector2[] = [];
    const edges = params.edges;
    for (let i = 0; i < edges.length; i++) {
      const edge = edges[i];
      if (!isArc(edge)) {
        lines.push(new Vector2(edge.start.x / pixelRatio2d, edge.start.y / pixelRatio2d));
        lines.push(new Vector2(edge.end.x / pixelRatio2d, edge.end.y / pixelRatio2d));
        continue;
      }

      // 圆弧处理
      const arc = new ArcSeg2d({
        start: edge.start,
        end: edge.end,
        center: edge.center,
        clockwise: edge.clockwise
      });

      const points = arc.getPoints();
      for (let j = 0; j < points.length - 1; j++) {
        lines.push(new Vector2(points[j].x / pixelRatio2d, points[j].y / pixelRatio2d));
        lines.push(new Vector2(points[j + 1].x / pixelRatio2d, points[j + 1].y / pixelRatio2d));
      }
    }

    this.clear();

    this._lines = lines;

    if (this._lines.length) {
      this.createModel();
    }
  }

  private createModel() {
    const lines = this._lines;
    const lineGmt = new BufferGeometry();
    lineGmt.setFromPoints(lines);

    const line = new LineSegments(lineGmt, this._lineMaterial);

    this.modelGroup.add(line);
  }

  override clear() {
    super.clear();
  }
}
